<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.BUSINESSNAME' | translate }}
				</td>
				<!-- <td
					class=" text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.COUNTRY' | translate }}
				</td> -->
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.MOBILENUMBER' | translate }} /
					{{ 'GENERAL_LABELS.EMAIL' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.SERVICEPROVIDERTYPE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.DATE' | translate }}
				</td>
				<td
					*ngIf="organizationFilter.status == 2"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'ORGANIZATION.ORGANIZATION_LIST.ISACTIVE' | translate }}
				</td>
				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let organization of organizations
						| paginate
							: {
									itemsPerPage: organizationFilter?.paging?.pageSize,
									currentPage: organizationFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != organizations?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					(click)="takeAction('view', organization)"
					class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
					>
						<img
							[src]="imagePath + organization?.logoUrl"
							alt=""
							class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
						/>
						<span>
							<span class="block whitespace-normal text-dark-grey">
								<img
									(mouseout)="inCompleteDataHover = false; hoverId = null"
									(mouseover)="
										inCompleteDataHover = true; hoverId = organization.id
									"
									*ngIf="!organization?.isBranchesInformationCompleted"
									alt=""
									class="inline-block w-4"
									src="assets/images/new-danger.svg"
								/>
								{{ organization?.businessName | slice : 0 : 15 }}
								{{ organization.businessName.length > 15 ? '...' : '' }}
								<div
									*ngIf="inCompleteDataHover && hoverId == organization?.id"
									class="absolute bg-main-color-black px-[16px] py-12px text-off-white text-font-14 rounded-[4px] max-w-[344px] top-[30px] left-[65px] z-10"
								>
									{{
										'ORGANIZATION.ORGANIZATION_LIST.BRANCH_INFO_MISSING'
											| translate
									}}
								</div>
							</span>
							<span class="text-medium-gray">
								{{ organization.branchTotalCount }}
								{{
									(organization.branchTotalCount > 1
										? 'ORGANIZATION.ORGANIZATION_LIST.BRANCHS'
										: 'ORGANIZATION.ORGANIZATION_LIST.BRANCH'
									) | translate
								}}
							</span>
						</span>
					</span>
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12">
						{{ organization?.mobileNumber }}
					</h1>
					<h1
						*ngIf="!organization.mobileNumber && organization?.email"
						class="text-font-16 text-dark-grey max-mobile:text-font-12"
					>
						{{ organization?.email | slice : 0 : 15 }}
						{{ organization.email.length > 15 ? '...' : '' }}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						translate.currentLang === 'ar'
							? organization.serviceProviderType?.name?.ar
							: organization.serviceProviderType?.name?.en
					}}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ organization?.date | date : 'dd / MM / yyy' }}
				</td>
				<td
					*ngIf="organizationFilter.status == 2"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<app-status
						[enumData]="statusEnum"
						[statusValue]="organization.isActive"
					></app-status>
				</td>
				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span class="inline-block max-mobile:w-[20px] w-[16px] text-end">
						<img
							(click)="takeAction('view', organization)"
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
